import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  wrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '15px 30px',
    border: '1px solid #E2EBF6',
    borderRadius: '3px',
    marginBottom: '6px',
    '&:last-child': {
      marginBottom: 0
    }
  },
  info: {
    width: '469px'
  },
  title: {
    fontWeight: 'bold',
    marginBottom: '2px'
  },
  actions: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  iconButton: {
    color: '#59758B'
  }
});
